export const parseQueryString = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const params = {};
  for (let [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  return params;
};

export const validateNumber = function (phoneNumber) {
  // Validate Number length and normalize to +e164
  var phoneNumberPattern = /^\(?\+?1?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  if (phoneNumberPattern.test(phoneNumber)) {
    if (phoneNumber[0] == 1) {
      phoneNumber = "+" + phoneNumber.replace(/\D/g, "");
    } else if (phoneNumber[0] == "+") {
      phoneNumber = "+" + phoneNumber.replace(/\D/g, "");
    } else {
      phoneNumber = "+1" + phoneNumber.replace(/\D/g, "");
    }
    return phoneNumber;
  } else {
    return false;
  }
};

export const formatPhoneNumber = function (phoneNumber) {
  // Format phone number to (xxx) xxx-xxxx
  var phoneNumberPattern = /^\+?1?(\d{3})(\d{3})(\d{4})$/;
  if (phoneNumberPattern.test(phoneNumber)) {
    var formattedPhoneNumber = phoneNumber.replace(
      phoneNumberPattern,
      "($1) $2-$3"
    );
    return formattedPhoneNumber;
  } else {
    return false;
  }
};

export const captureBooking = async function (appointment) {
  const captureUrl = `${import.meta.env.VITE_API_URL}/bookings/capture`;

  const capturePayload = {
    domain: appointment?.domain,
    siteId: appointment?.shopData?.shopId,
    fname: appointment?.customer?.fname,
    lname: appointment?.customer?.lname,
    number: appointment?.customer?.phone,
    email: appointment?.customer?.email,
    apptType: appointment?.apptType,
    duration: appointment?.service?.hours,
    title: appointment?.service?.name,
    bailOutStage: appointment?.bailOutStage,
    comments: appointment?.comments,
    date: appointment.date,
    time: appointment.time,
    service: appointment.service,
    newAppointmentId: appointment.bookingId,
    bailed: appointment.bailed,
  };

  try {
    // First fetch call for capture
    const captureResponse = await fetch(captureUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(capturePayload),
    });

    if (!captureResponse.ok) {
      throw new Error(
        "Network response was not ok " + captureResponse.statusText
      );
    }

    const captureData = await captureResponse.json();
    return captureData;
  } catch (error) {
    console.error("Error posting booking config:", error);
  }
};

export const customerLookup = async function (customer, config) {
  const url = `${import.meta.env.VITE_API_URL}/bookings/customerLookup?domain=${config.domain}&shopId=${config.shopId}&number=${customer}`;

  try {
    const response = await fetch(url);
    return response.json();
  } catch (error) {
    console.error("Error fetching customer data", error);
  }
};

export const serviceLookup = async function (customer, config) {
  const url = `${import.meta.env.VITE_API_URL}/bookings/serviceLookup?domain=${config.domain}&shopId=${config.shopId}&cid=${customer._id}&vid=${customer.vehicle_id}`;

  try {
    const response = await fetch(url);
    return response.json();
  } catch (error) {
    console.error("Error fetching customer data", error);
  }
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const sendToWindowDataLayer = (event, service) => {
  // Check if we're running inside an iframe
  const isInIframe = window.self !== window.top;

  if (isInIframe) {
    // If in iframe, send event data to parent window via postMessage
    const eventData = {
      type: "GTM_EVENT",
      event: event,
      clickText: service,
      timestamp: new Date().toISOString(),
      source: "dc-booking-iframe",
    };

    try {
      // Check if parent window exists and is accessible
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(eventData, "*");
      }
    } catch (error) {
      console.warn("GTM: Failed to send event to parent window:", error);
    }

    // Also try to push to local dataLayer as fallback
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        clickText: service,
        iframe_source: "dc-booking-iframe",
      });
    } catch (fallbackError) {
      console.warn("GTM: Failed to push to local dataLayer:", fallbackError);
    }
  } else {
    // If not in iframe, use normal dataLayer push
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      clickText: service,
    });
  }
};
